<template>
  <div class="position-relative p-0">
    <label class="btn bg-primary text-white w-100" @click="showDeleteBtn">
      <input :disabled="talk_form" ref="input" type="file" :accept="fileType" @input="doInput($event)" />
      <span class="icon cil-paperclip icon-l" />
    </label>
    <span v-if="filename" class="position-absolute top-0 start-100 translate-middle badge rounded-pill align-self-center bg-info p-2 mt-1 me-1">
      <span class="visually-hidden">{{ filename }}</span>
    </span>
    <base-button
      :class="isShow ? 'd-block' : 'd-none'"
      class="btn btn-talk-delete bg-white border shadow position-absolute end-100 px-3 py-1 mr-1"
      @click="doDelete" text="削除"
    />
  </div>
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';
import { mapState } from 'vuex';

export default {
  name: 'TalkFileUpload',
  components: {
    BaseButton,
  },
  emits: ['delete'],
  props: {
    filename: {
      type: String,
      default: '',
    },
    setHandler: {
      type: Function,
      default: () => {},
    },
    fileType: {
      type: String,
      default: '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.png,.jpeg,.jpg',
    },
    isInvalid: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('issuance_request_form', {
      talk_form: state => state.talk_form.upload_file,
    }),
  },
  data() {
    return {
      isShow: false,
    };
  },
  watch: {
    filename() {
      if (!this.filename) {
        this.isShow = false;
      }
    },
  },
  methods: {
    doInput(event) {
      if(!event.target.files[0]) {
        return;
      }
      this.setHandler(event.target.files[0]);
      this.$refs.input.value = null;
    },
    showDeleteBtn() {
      if (this.filename) {
        this.isShow = !this.isShow;
      }
    },
    doDelete() {
      this.$emit('delete');
      this.isShow = false;
    },
  }
}
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.btn-talk-delete {
  width: max-content;
  margin-right: 3px;
  bottom: 3px;
}
</style>
